import React, { useContext, FC } from "react";
import { Flag } from "../types";
import { updateFlag, refreshMyProfile, logout } from "../actions";
import UserContext from "../contexts/userContext";
import { History } from "history";
import withRedux from "../withRedux";
import { _ } from "libs";

type Props = {
	history: History;
	refreshMyProfile: typeof refreshMyProfile;
	logout: typeof logout;
};

const TOSReview: FC<Props> = ({ history, refreshMyProfile, logout }: Props) => {
	const { profile } = useContext(UserContext);

	if (profile.flags && profile.flags.mustAcceptTOC === 0) {
		history.push("/");
	}

	const accept = async () => {
		await updateFlag(Flag.MustAcceptTOC, 0);
		await refreshMyProfile();
		history.push("/");
	};

	const reject = async () => {
		const ok = window.confirm(_("tosReview.rejectConfirmation"));
		if (ok) {
			logout();
		}
	};

	return (
		<div className="boxWrap">
			<div className="box tosReview">
				<div className="boxLeader">
					<div className="symbol document" />
					<h2>{_("tosReview.heading")}</h2>
				</div>
				<div className="boxContent">
					<p className="description">{_("tosReview.description")}</p>
					<p>
						<a
							className="link"
							href="https://www.gotcourts.com/en_CH/tos"
							target="_blank"
							rel="noopener noreferrer"
						>
							{_("tosReview.tosLink")}
						</a>
					</p>
					<p>
						<a
							className="link"
							href="https://www.gotcourts.com/en_CH/policy"
							target="_blank"
							rel="noopener noreferrer"
						>
							{_("tosReview.privacyPolicyLink")}
						</a>
					</p>
					<div className="actions">
						<button onClick={accept} className="button done fullWidth">
							{_("tosReview.acceptBtn")}
						</button>
						<button onClick={reject} className="button light fullWidth">
							{_("tosReview.rejectBtn")}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default withRedux({ refreshMyProfile, logout }, null)(TOSReview);
